<script>
    export default {
        props: {
            docs: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                open: false
            }
        },
    }
</script>

<template>
    <div id="docs" class="row">
        <table>
            <tr>
                <td class="docs-navigation" style="width:176px;vertical-align: top;">
                    <img src="@assets/images/docs-nav.png" alt="Logo" />
                </td>
                <td class="docs-content" style="vertical-align: top;">
                    <div id="docs-content" class="col-auto p-3"  v-html="docs"></div>
                </td>
            </tr>
        </table>

        </div>

    </div>
</template>

<style lang="scss" >
    @import '@design';

    #docs{
        background-color:#343131;
        font-family: Lato;
        font-size:12px;
        line-height: 180%;
    }

    .docs-content{
        background-color:#f9f9f9;
    }

     #docs h1, #docs h2, #docs h3, #docs h4, #docs h5, #docs h6{
         font-family: Lato;
        line-height: 140%;
         margin-top:22px;
         margin-bottom:0em;

     }
      #docs h1{
        font-size:24px;
        padding-bottom:0px;
        margin-bottom:0px;
      }
    #docs h2{
        font-size:22px;
        padding-bottom:0px;
        margin-bottom:0px;
    }

    #docs h3{
        font-size:18px;
    }


    table{
        width:100%;
    }
    table tr{
        border-bottom:1px solid #ccc;
    }
    table th{
        text-transform: uppercase;
        font-weight: 400;
        color:grey;
        margin-bottom:20px;
    }
</style>
